import { Add, MapsHomeWork } from "@mui/icons-material";
import { Badge, Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import FormDrawer from "components/Shared/FormDrawer";
import { toast } from "react-toastify";
import WardForm from "./WardForm";
import WardList from "./WardList";

import { useTablePagination } from "hooks";
import { useUpdateMunicipalityMutation } from "store/services/LocationsApi/municipalityApi";

const WardsTab = ({ municipalityDetail }) => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const [showWardForm, setShowWardForm] = React.useState(false);

  const [updateWard, { isLoading: updatingWard }] =
    useUpdateMunicipalityMutation();

  const handleUpdateWard = async (data) => {
    try {
      await updateWard({
        ...data,
        id: municipalityDetail?._id,
      }).unwrap();
      toast.success("Ward added successfully");
      setShowWardForm(false);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't add ward!");
    }
  };

  const handleCancelWard = () => {
    setShowWardForm(false);
  };
  return (
    <>
      <Box
        display="flex"
        alignItems="end"
        justifyContent="space-between"
        padding={2}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge
            badgeContent={municipalityDetail?.wards?.length}
            color="primary"
          >
            <MapsHomeWork style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Wards</Typography>
        </Box>

        {!showWardForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowWardForm(true)}
          >
            Ward
          </Button>
        )}
      </Box>

      <Divider />
      <WardList
        municipalityWards={municipalityDetail?.wards}
        municipalityDetail={municipalityDetail}
        isBusy={updatingWard}
        totalWards={municipalityDetail?.wards?.length}
        perPage={perPage}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handlePerRowsChange={handlePerRowsChange}
      />

      <FormDrawer
        title="Add Ward"
        open={showWardForm}
        onClose={handleCancelWard}
      >
        <WardForm
          municipalityDetail={municipalityDetail}
          isBusy={updatingWard}
          onSubmit={(data) => handleUpdateWard(data)}
          onCancel={handleCancelWard}
        />
      </FormDrawer>
    </>
  );
};

export default WardsTab;
